/**
 * Clipboard: a rounded board with its clip and nothing on it yet.
 *
 * Progress lifts the clip a little off the board and lets it settle back,
 * once a cycle. See Clipboard for the drawing.
 *
 * Color slots: 0 the board and its clip.
 */import*as React from"react";import Clipboard from"web/shared/icons/glyphs/Clipboard";import{TAU,wrapProgress}from"web/shared/icons/progress";import{jsx as _jsx}from"react/jsx-runtime";// The clip's highest lift, which keeps its stroke inside the 24 box.
const MAXIMUM_LIFT=1.2;function ClipboardGlyph(props){const progress=wrapProgress(props.progress);// Up and back down in one smooth swell, at rest at either end.
const lift=MAXIMUM_LIFT*(1-Math.cos(TAU*progress))/2;return/*#__PURE__*/_jsx(Clipboard,{clipLift:lift,contents:()=>null,colors:props.colors});}export default ClipboardGlyph;